import cx from 'classnames';
import {
    COVID19_WARNING__NAME,
    COVID19_WARNING__STAYHOME,
    COVID19_WARNING__WIKILINK,
    FORUM_READ_MORE,
} from 'mk/autogenerated/translations/CovidPanel.1da9d582f630d6b0cd7e9d05fa7fbcbb'
import React from 'react';
import styles from './CovidPanel.mscss';

export const DISPLAY_COVID_PANEL = false;

interface OwnProps {
    isMobile: boolean;
    isInForum?: boolean;
    isMobileMenu?: boolean;
    isInBazar?: boolean;
}

type Props = OwnProps;

const CovidPanel = React.memo<Props>(({ isInForum, isInBazar, isMobile, isMobileMenu }) => {
    return (
        <a href={COVID19_WARNING__WIKILINK}>
            <div className={cx(styles.CovidPanel__box, isInBazar && styles['CovidPanel__box--inBazar'], isInForum && styles['CovidPanel__box--inForum'], isMobileMenu && styles['CovidPanel__box--inMobileMenu'])}>
                <div className={styles.CovidPanel__text}>
                    <b>{COVID19_WARNING__NAME}:</b> {COVID19_WARNING__STAYHOME}
                    &nbsp;
                    <span className={styles.CovidPanel__fakeLink}>
                        {FORUM_READ_MORE}
                    </span>
                </div>
            </div>
        </a>
    );
});

CovidPanel.displayName = 'CovidPanel';

export default CovidPanel;
